import { Component, Input } from '@angular/core';
import { NavigationService } from '@rci/self-serve-fido/shared/navigation-service/navigation-service.service';
import { AppAlert } from '@rogers/self-serve-common/alert';

@Component({
  selector: 'fss-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {
  @Input() profileAlerts: AppAlert[];

  constructor(private readonly navigationService: NavigationService) {}

  setAccountNumberAndNavigate = $event => this.navigationService.setAccountNumberAndNavigate($event.key, $event.url);
}
